export enum conferenceTypes {
    FETCH_CONFERENCE_REQUEST = 'FETCH_CONFERENCE_REQUEST',
    FETCH_CONFERENCE_BY_ID_REQUEST = 'FETCH_CONFERENCE_BY_ID_REQUEST',
    EDIT_CONFERENCE = 'EDIT_CONFERENCE',
    CREATE_CONFERENCE_REQUEST = 'CREATE_CONFERENCE_REQUEST',
    DELETE_CONFERENCE_REQUEST = 'DELETE_CONFERENCE_REQUEST',
    SET_CONFERENCE = 'SET_CONFERENCE',
    SET_RELATIVE_CONERENCE = 'SET_RELATIVE_CONERENCE',
}
